// Pieces of the manual checks shared by the list in the results, the guide page and the problem cards: who can
// do a guide, what an answer is called and where an aspect stands. Saying that something was recorded is kept
// apart from saying that it was passed: no text here equates one with the other.
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { buttonClass } from '../ui';

/** «Revisión guiada» or «Puede requerir ayuda especializada»: who can follow the steps. */
export function HelpBadge({ help }: { help: 'guiada' | 'especializada' | null }) {
  const { t } = useTranslation();
  const key = help ?? 'none';
  return (
    <span className="origin-chip manual-help" data-help={key}>
      {t(`manual.help.${key}`)}
    </span>
  );
}

/** The search of the guide page: where to go back to and what the review starts from. */
export interface ReviewSearch {
  /** The page the review starts on. */
  p?: string;
  /** The element the team follows that this review checks. */
  occurrence?: string;
  /** The review this one repeats. */
  previous?: string;
  /** A draft to resume. */
  r?: string;
  /** The analysis the person came from (the results to go back to). */
  scan?: string;
}

/** A link to the guide of a criterion, with what the review should start from. */
export function GuideLink({
  siteId,
  criterion,
  search,
  children,
  variant = 'secondary',
}: {
  siteId: string;
  criterion: string;
  search?: ReviewSearch;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
}) {
  return (
    <Link
      to="/sites/$siteId/revision-manual/$criterion"
      params={{ siteId, criterion }}
      search={search ?? {}}
      className={buttonClass(variant)}
    >
      {children}
    </Link>
  );
}
